/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,

  Button,
  Snackbar,
  Alert,
  InputLabel,

} from "@mui/material";

import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);



function FormDetails({ apCompanies, plates, inOut, inOutId }) {
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  //   const [apUsers, setApUsers] = useState(null);
  //   const [jobs, setJobs] = useState(null);
  const [selectedApCompany, setSelectedApCompany] = useState(inOut?.ap_company?._id);
  const [selectedSourceCompany, setSelectedSourceCompany] = useState(inOut?.source_company?._id || null);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (values, resetForm) => {
    try {
      //   setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/plate_inventory/inward_outward/plate_inventory/${inOutId}`,
        {
          ap_company: values.ap_company,
          plate: values.plate,
          entry_type: values.entry_type,
          quantity: values.quantity,
          remarks: values.remarks,
          source_company: values.source_company,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        setRows([]);
        navigate("/dashboard/inventory/pending-in-out", {
          state: { success: true, message: "Request Updated Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  useEffect(() => {
    console.log(err);
  }, [err]);

  return (
    <>
      <Formik
        initialValues={{
          plate: inOut?.plate?._id,
          entry_type: inOut?.entry_type,
          ap_company: inOut?.ap_company?._id,
          quantity: inOut?.quantity,
          remarks: inOut?.remarks,
          source_company: inOut?.source_company?._id,
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          ap_company: Yup.string().required("Ap Company is required"),
          plate: Yup.string().required("Plate is required"),
          quantity: Yup.number().required("Quantity is required"),
          entry_type: Yup.string().required("Entry Type is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          // <></>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Request updated Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update In/Out Request
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.plate && errors.plate)}
                        >
                          <Select
                            id="search-field"
                            onChange={(e) =>
                              setFieldValue("plate", e.target.value)
                            }
                            value={values.plate}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Select Plate
                            </MenuItem>
                            {plates.map((plate) => {
                              return (
                                <MenuItem key={plate._id} value={plate._id}>
                                  {plate.height}X{plate.width}X{plate.thickness}{" "}
                                  || {plate.brand.name} ||{" "}
                                  {plate.technology.name} {" "}
                                  || {" "} {plate.company}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(
                            touched.entry_type && errors.entry_type
                          )}
                        >
                          <InputLabel id="label"> Type * </InputLabel>
                          <Select
                            labelId="label"
                            fullWidth
                            id="label"
                            label="Select Type"
                            onChange={(e) =>
                              setFieldValue("entry_type", e.target.value)
                            }
                            value={values?.entry_type}
                          >
                            <MenuItem disabled value={""}>
                              Select Type To
                            </MenuItem>

                            <MenuItem value={"inward"}>
                              <Typography color="#33B897">Inward</Typography>
                            </MenuItem>
                            <MenuItem value={"outward"}>
                              <Typography color="tomato">Outward</Typography>
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(
                            touched.ap_company && errors.ap_company
                          )}
                        >
                          <Select
                            id="search-field"
                            onChange={(e) => {
                              setFieldValue("ap_company", e.target.value)
                              setSelectedApCompany(e.target.value);
                            }
                            }
                            value={values.ap_company}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Select Ap company
                            </MenuItem>
                            {apCompanies.filter((apCompany) => {
                              return apCompany._id !== selectedSourceCompany;
                            }).map((apCompany) => {
                              return (
                                <MenuItem
                                  key={apCompany._id}
                                  value={apCompany._id}
                                >
                                  {apCompany.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                       <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                        // error={Boolean(
                        //   touched.ap_company && errors.ap_company
                        // )}
                        >
                          <Select
                            id="search-field"
                            onChange={(e) => {
                              setFieldValue("source_company", e.target.value);
                              setSelectedSourceCompany(e.target.value);
                            }
                            }
                            value={values?.source_company || "Other"}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Select Source company
                            </MenuItem>
                            {apCompanies.filter((apCompany) => {
                              return apCompany._id !== selectedApCompany;
                            }).map((apCompany) => {
                              return (
                                <MenuItem
                                  key={apCompany._id}
                                  value={apCompany._id}
                                >
                                  {apCompany.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          type="number"
                          fullWidth
                          name="quantity"
                          value={values.quantity}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.quantity && errors.quantity)}
                          id="search-field"
                          label="Quantity * "
                          helperText={touched.quantity && errors.quantity}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="remarks"
                          value={values.remarks}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.remarks && errors.remarks)}
                          id="search-field"
                          label="Remarks"
                          helperText={touched.remarks && errors.remarks}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Update Request
                        </Button>
                        {/* <Button
                          style={{ textAlign: "center", background: "red" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                        >
                          Reset
                        </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getApCompaniesAndPlates = async (
  setApCompanies,
  setPlates,
  setLoader
) => {
  setLoader(true);
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let url = `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies?page=1&limit=1000`;

    const apCompanies = await axios.get(url, config);
    if (apCompanies.data.success) {
      let finalData = apCompanies.data.data;
      setApCompanies(finalData);
    }
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory?limit=1000`,
      config
    );
    if (data.success) {
      setPlates(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const getInOut = async (in_out_id, setInOut, setLoader) => {
  setLoader(true);
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };

    const inOut = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory/inward_outward/plate_inventory/${in_out_id}`,
      config
    );
    if (inOut.data.success) {
      let result = inOut.data.data;
      let plate = result.plate;
      let plate_name = `${plate.height}X${plate.width}X${plate.thickness}${" "}
          || ${plate.brand.name} ||${" "}
          ${plate.technology.name}`;
      plate.name = plate_name;
      setInOut(inOut.data.data);
    }

    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function UpdateInOut() {
  const [plates, setPlates] = useState([]);
  const [apCompanies, setApCompanies] = useState([]);
  const [inOut, setInOut] = useState(null);

  const { in_out_id } = useParams();

  const [loader, setLoader] = useState(true);
  const [apUsers, setApUsers] = useState([]);

  useEffect(() => {
    getApCompaniesAndPlates(setApCompanies, setPlates, setInOut, setLoader);
    getInOut(in_out_id, setInOut, setLoader);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE IN-OUT
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Link
                component={NavLink}
                to="/dashboard/inventory/pending-in-out"
              >
                Pending In-Out
              </Link>
              <Typography>Update</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              apCompanies={apCompanies}
              plates={plates}
              inOut={inOut}
              inOutId={in_out_id}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default UpdateInOut;
